import type { Bilingual } from '../i18n/types';


interface Props {
  value: Bilingual;
  className?: string;
  separator?: 'newline' | 'slash';
}

/**
 * JP/VN 併記テキスト。改行 or '/' で区切る。
 */
export function BilingualText({ value, className, separator = 'newline' }: Props) {
  if (separator === 'slash') {
    return (
      <span className={className}>
        {value.ja} / {value.vi}
      </span>
    );
  }
  return (
    <span className={className}>
      <span className="bi-ja">{value.ja}</span>
      <span className="bi-vi">{value.vi}</span>
    </span>
  );
}
